<label>
    <input type="radio" [ngModel]="model" (ngModelChange)="modelChange.emit($event)" [value]="ttValue" [name]="name" />
    <span>{{ label }} </span>
</label>
